import { render, staticRenderFns } from "./Appealinfo.vue?vue&type=template&id=ec9baeb8"
import script from "./Appealinfo.vue?vue&type=script&lang=js"
export * from "./Appealinfo.vue?vue&type=script&lang=js"
import style0 from "./Appealinfo.vue?vue&type=style&index=0&id=ec9baeb8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports